/**
 * Important NOTE: Do not add global to urls as these are already handled by click handler of footer component
 */
export const megaMenuFooterDataRegional = [
  {
    title: 'Popular TV Shows',
    slug: '/tv-shows',
    items: [
      {
        title: 'Mahabharat',
        slug: '/tv-shows/details/mahabharat/0-6-3331'
      },
      {
        title: 'Kahan ho Tum',
        slug: '/tv-shows/details/kahan-ho-tum/0-6-3395'
      },
      {
        title: 'Jhansi ki Rani',
        slug: '/tv-shows/details/jhansi-ki-rani/0-6-124'
      },
      {
        title: 'Kumkum Bhagya',
        slug: '/tv-shows/details/kumkum-bhagya/0-6-127'
      },
      {
        title: 'Kundali Bhagya',
        slug: '/tv-shows/details/kundali-bhagya/0-6-366'
      },
      {
        title: 'Bhagya Lakshmi',
        slug: '/tv-shows/details/bhagya-lakshmi/0-6-3392'
      },
      {
        title: 'Meet',
        slug: '/tv-shows/details/meet/0-6-3510'
      },
      {
        title: 'Annapoorna',
        slug: '/tv-shows/details/annapoorna/0-6-4z5250953'
      },
      {
        title: 'Indira',
        slug: '/tv-shows/details/indira/0-6-4z5250031 '
      },
      {
        title: 'Korean Drama',
        slug: '/collections/free-korean-tv-shows/0-8-1017'
      },
      {
        title: 'Pakistani Serials',
        slug: '/collections/pakistani-shows/0-8-3z5367858'
      }
    ]
  },
  {
    title: 'Premium Movies',
    slug: '/movies',
    items: [
      {
        title: 'Berlin',
        slug: '/movies/details/berlin/0-0-1z5615527'
      },
      {
        title: 'Bhaiyya Ji',
        slug: '/movies/details/bhaiyya-ji/0-0-1z5595126'
      },
      {
        title: 'Kakuda',
        slug: '/movies/details/kakuda/0-0-1z5581177'
      },
      {
        title: 'Rautu Ka Raaz',
        slug: '/movies/details/rautu-ka-raaz/0-0-1z5577122'
      },
      {
        title: 'Swatantrya Veer Savarkar',
        slug: '/movies/details/swatantrya-veer-savarkar/0-0-1z5566630'
      },
      {
        title: 'Bastar',
        slug: '/movies/details/bastar-the-naxal-story/0-0-1z5559828'
      },
      {
        title: 'Main Atal Hoon',
        slug: '/movies/details/main-atal-hoon/0-0-1z5528544'
      },
      {
        title: 'The Kerala Story',
        slug: '/movies/details/the-kerala-story/0-0-1z5512788'
      },
      {
        title: 'Silence 2',
        slug: '/movies/details/silence-2-the-night-owl-bar-shootout/0-0-1z5535878'
      },
      {
        title: 'Sam Bahadur',
        slug: '/movies/details/sam-bahadur/0-0-1z5500337'
      },
      {
        title: 'Kadak Singh',
        slug: '/movies/details/kadak-singh/0-0-1z5469034'
      },
      {
        title: 'Gadar 2',
        slug: '/movies/details/gadar-2/0-0-1z5437988'
      },
      {
        title: 'Hanu-Man',
        slug: '/movies/details/hanu-man/0-0-1z5531939'
      },
      {
        title: 'Bandaa',
        slug: '/movies/details/sirf-ek-bandaa-kaafi-hai/0-0-1z5359029'
      },
      {
        title: 'RRR',
        slug: '/movies/details/rrr/0-0-1z5145092'
      },
      {
        title: 'Uri: The Surgical Strike',
        slug: '/movies/details/uri-the-surgical-strike/0-0-33204 '
      }
    ]
  },
  {
    title: 'Popular LIVE TV Channels',
    slug: '/live-tv',
    items: [
      {
        title: 'Zee TV HD',
        slug: '/live-tv/zee-tv-hd/0-9-zeetvhd'
      },
      {
        title: '&TV HD',
        slug: '/live-tv/andtv-hd/0-9-tvhd_0'
      },
      {
        title: 'Zee Marathi HD',
        slug: '/live-tv/zee-marathi-hd/0-9-zeemarathi'
      }
    ]
  },
  {
    title: 'Popular Web Series',
    slug: '/web-series',
    items: [
      {
        title: 'Murshid',
        slug: '/web-series/details/murshid/0-6-4z5612057'
      },
      {
        title: 'Gyaarah Gyaarah',
        slug: '/web-series/details/gyaarah-gyaarah/0-6-4z5371966'
      },
      {
        title: 'Manorathangal',
        slug: '/web-series/details/manorathangal/0-6-4z5594936'
      },
      {
        title: 'Kaantaye Kaantaye',
        slug: '/web-series/details/kaantaye-kaantaye/0-6-4z5598539'
      },
      {
        title: 'Paruvu',
        slug: '/web-series/details/paruvu/0-6-4z5570736'
      },
      {
        title: 'Thalaimai Seyalagam',
        slug: '/web-series/details/thalaimai-seyalagam/0-6-4z5556586'
      },
      {
        title: 'The Broken News',
        slug: '/web-series/details/the-broken-news/0-6-4z5145215'
      },
      {
        title: 'Love Bites',
        slug: '/web-series/details/love-bites/0-6-2135'
      },
      {
        title: 'Black Widows',
        slug: '/web-series/details/black-widows/0-6-3029'
      },
      {
        title: 'Duranga 2',
        slug: '/web-series/details/duranga/0-6-4z5193948'
      },
      {
        title: 'Shikarpur',
        slug: '/web-series/details/shikarpur/0-6-4z5273911'
      },
      {
        title: 'Taj',
        slug: '/web-series/details/taj/0-6-4z5311140'
      },
      {
        title: 'Sunflower',
        slug: '/web-series/details/sunflower/0-6-3284'
      },
      {
        title: 'Tripling',
        slug: '/web-series/details/tripling/0-6-3350'
      },
      {
        title: 'Pitchers',
        slug: '/web-series/details/pitchers/0-6-3348'
      }
    ]
  },
  {
    title: 'Bollywood Top Celebrities',
    slug: 'https://www.zee5.com/zee5news/celebs',
    external: true,
    items: [
      {
        title: 'Sunny Leone',
        slug: 'https://www.zee5.com/celebs/sunny-leone',
        external: true
      },
      {
        title: 'Disha Patani',
        slug: 'https://www.zee5.com/celebs/disha-patani',
        external: true
      },
      {
        title: 'Deepika Padukone',
        slug: 'https://www.zee5.com/celebs/deepika-padukone',
        external: true
      },
      {
        title: 'Salman Khan',
        slug: 'https://www.zee5.com/celebs/salman-khan',
        external: true
      },
      {
        title: 'Manoj Bajpayee',
        slug: 'https://www.zee5.com/celebs/manoj-bajpayee',
        external: true
      },
      {
        title: 'Pankaj Tripathi',
        slug: 'https://www.zee5.com/celebs/pankaj-tripathi',
        external: true
      },
      {
        title: 'Vicky Kaushal',
        slug: 'https://www.zee5.com/celebs/vicky-kaushal',
        external: true
      },
      {
        title: 'Sunny Deol',
        slug: 'https://www.zee5.com/celebs/sunny-deol',
        external: true
      },
      {
        title: 'Ameesha Patel',
        slug: 'https://www.zee5.com/celebs/ameesha-patel',
        external: true
      },
      {
        title: 'Abhishek Bachchan',
        slug: 'https://www.zee5.com/celebs/abhishek-bachchan',
        external: true
      },
      {
        title: 'Amitabh Bachchan',
        slug: 'https://www.zee5.com/celebs/amitabh-bachchan',
        external: true
      },
      {
        title: 'Kangana Ranaut',
        slug: 'https://www.zee5.com/celebs/kangana-ranaut',
        external: true
      }
    ]
  },
  {
    title: 'Games',
    items: [
      {
        title: 'Play',
        slug: 'https://www.zee5.com/play5-games/',
        external: true
      },
      {
        title: 'Stories',
        slug: 'https://www.zee5.com/stories/',
        external: true
      }
    ]
  }
];
//global footer data
export const MegaMenuFooterDataGlobal = [
  {
    title: 'Indian Movies Collection',
    slug: '',
    items: [
      {
        title: 'Indian Horror Movies',
        slug: '/movies/genre/horror/hindi'
      },
      {
        title: 'Indian Comedy Movies',
        slug: '/movies/genre/comedy/hindi'
      },
      {
        title: 'Indian Action Movies',
        slug: '/movies/genre/action/hindi'
      },
      {
        title: 'Indian Crime Movies',
        slug: '/movies/genre/crime/hindi'
      },
      {
        title: 'Bollywood Romance Movies  ',
        slug: '/movies/genre/romance/hindi'
      }
    ]
  },
  {
    title: 'TV Shows by language',
    slug: '',
    items: [
      {
        title: 'Hindi Tv Shows & Serials',
        slug: '/tv-shows/lang/hindi'
      },
      {
        title: 'Tamil Tv Shows & Serials',
        slug: '/tv-shows/lang/tamil'
      },
      {
        title: 'Telugu Tv Shows & Serials',
        slug: '/tv-shows/lang/telugu'
      },
      {
        title: 'Marathi Tv Shows & Serials',
        slug: '/tv-shows/lang/marathi'
      },
      {
        title: 'Malayalam Tv Shows & Serials',
        slug: '/tv-shows/lang/malayalam'
      }
    ]
  },
  {
    title: 'Language Webseries On ZEE5',
    slug: '',
    items: [
      {
        title: 'Hindi Webseries',
        slug: '/web-series/lang/hindi'
      },
      {
        title: 'Tamil Webseries',
        slug: '/web-series/lang/tamil'
      },
      {
        title: 'Telugu Webseries',
        slug: '/web-series/lang/telugu'
      },
      {
        title: 'Hindi Drama Series',
        slug: '/web-series/genre/drama/hindi'
      },
      {
        title: 'Bangla Webseries',
        slug: '/web-series/lang/bangla'
      }
    ]
  },
  {
    title: 'Actor Movies',
    slug: '',
    items: [
      {
        title: 'Deepika Padukone Movies',
        slug: '/celebs/deepika-padukone/filmograpghy'
      },
      {
        title: 'Salman Khan Movies',
        slug: '/celebs/salman-khan/filmograpghy'
      },
      {
        title: 'Amitabh Bachan Movies',
        slug: '/celebs/amitabh-bachan/filmograpghy'
      },
      {
        title: 'Shahrukh Khan Movies',
        slug: '/celebs/shahrukh-khan/filmograpghy'
      },
      {
        title: 'Priyanka Chopra Movies',
        slug: '/celebs/priyanka-chopra/filmograpghy'
      }
    ]
  },
  {
    title: 'Popular & Upcoming Movies',
    slug: '',
    items: [
      {
        title: 'Bastar',
        slug: '/movies/details/bastar-the-naxal-story/0-0-1z5559828'
      },
      {
        title: 'Silence 2',
        slug: '/movies/details/silence-2-the-night-owl-bar-shootout/0-0-1z5535878'
      },
      {
        title: 'Farrey ',
        slug: '/movies/details/farrey/0-0-1z5535565'
      },
      {
        title: 'Hanu-man',
        slug: '/movies/details/hanu-man/0-0-1z5531939'
      },
      {
        title: 'Sam Bahadur',
        slug: '/movies/details/sam-bahadur/0-0-1z5500337'
      }
    ]
  }
];

export const childFooterDataGlobal = [
  // Allowed country code for MENA Region //
  {
    allowedCountryRegionsList: [
      'DZ',
      'EG',
      'IR',
      'LY',
      'MA',
      'SD',
      'TN',
      'EH',
      'BH',
      'CY',
      'IQ',
      'JO',
      'KW',
      'LB',
      'OM',
      'PS',
      'QA',
      'SA',
      'SY',
      'TR',
      'AE',
      'YE'
    ],
    footerData: [
      {
        title: 'Entertainment',
        link: '',
        data: [
          {
            title: 'Zee Kannada HD',
            link: '/live-tv/zee-kannada-hd/0-9-zeekannada'
          },
          {
            title: 'Zee Keralam HD',
            link: '/live-tv/zee-keralam-hd/0-9-129'
          },
          {
            title: 'Zee Tamil HD',
            link: '/live-tv/zee-tamil-hd/0-9-zeetamil'
          },
          {
            title: 'Zee Telugu HD',
            link: '/live-tv/zee-telugu-hd/0-9-zeetelugu'
          },
          {
            title: 'Zee TV ME',
            link: '/live-tv/zee-tv-me/0-9-tvme'
          }
        ]
      },
      {
        title: 'Movies',
        link: '',
        data: [
          {
            title: 'Zee Bangla Cinema',
            link: '/live-tv/zee-bangla-cinema/0-9-zeebanglacinema'
          },
          {
            title: 'Zee Cinema ME',
            link: '/live-tv/zee-cinema-me/0-9-zeecinemaintl'
          },
          {
            title: 'Zee Cinemalu HD',
            link: '/live-tv/zee-cinemalu-hd/0-9-zeecinemalu'
          },
          {
            title: 'Zee Talkies HD',
            link: '/live-tv/zee-talkies-hd/0-9-zeetalkies'
          },
          {
            title: 'Zee Thirai',
            link: '/live-tv/zee-thirai/0-9-224'
          }
        ]
      }
    ]
  },
  // Allowed country code for APAC Region //
  {
    allowedCountryRegionsList: [
      'IL',
      'UZ',
      'CN',
      'MN',
      'HK',
      'MO',
      'JP',
      'KP',
      'KR',
      'TW',
      'AS',
      'CX',
      'CC',
      'CK',
      'PF',
      'GU',
      'HM',
      'KI',
      'MH',
      'FM',
      'NR',
      'NC',
      'NU',
      'NF',
      'MP',
      'PW',
      'PG',
      'PN',
      'WS',
      'SB',
      'TK',
      'TO',
      'TV',
      'VU',
      'WF',
      'AU',
      'FJ',
      'NZ',
      'AF',
      'PK',
      'BT',
      'BN',
      'KH',
      'LA',
      'MM',
      'TL',
      'BD',
      'ID',
      'MY',
      'MV',
      'PH',
      'SG',
      'LK',
      'TH',
      'VN',
      'NP'
    ],
    footerData: [
      {
        title: 'Entertainment',
        link: '',
        data: [
          {
            title: 'Zee Tamil HD',
            link: '/live-tv/zee-tamil-hd-apac/0-9-360'
          },
          {
            title: 'Zee TV',
            link: '/live-tv/zee-tv-apac/0-9-zeetvapac'
          },
          {
            title: 'Zee Kannada HD',
            link: '/live-tv/zee-kannada-hd/0-9-zeekannada'
          },
          {
            title: 'Zee Marathi HD',
            link: '/live-tv/zee-marathi-hd/0-9-zeemarathi'
          },
          {
            title: '&TV HD',
            link: '/live-tv/andtv-hd/0-9-tvhd_0'
          }
        ]
      },
      {
        title: 'Movies',
        link: '',
        data: [
          {
            title: 'Zee Bollywood',
            link: '/live-tv/zee-bollywood/0-9-zeeclassic'
          },
          {
            title: 'Zee Cinemalu HD',
            link: '/live-tv/zee-cinemalu-hd/0-9-zeecinemalu'
          },
          {
            title: 'Zee Talkies HD',
            link: '/live-tv/zee-talkies-hd/0-9-zeetalkies'
          },
          {
            title: 'Zee Thirai',
            link: '/live-tv/zee-thirai/0-9-224'
          },
          {
            title: 'Zee Cinema',
            link: '/live-tv/zee-cinema-me/0-9-zeecinemaintl'
          }
        ]
      }
    ]
  },
  // Allowed country code for Europe Region //
  {
    allowedCountryRegionsList: [
      'AL',
      'BA',
      'HR',
      'MK',
      'ME',
      'RS',
      'EE',
      'LV',
      'LT',
      'BE',
      'LU',
      'NL',
      'CZ',
      'LI',
      'PL',
      'SK',
      'SI',
      'AZ',
      'KZ',
      'KG',
      'TJ',
      'TM',
      'AM',
      'GE',
      'BY',
      'BG',
      'GR',
      'HU',
      'MD',
      'RO',
      'UA',
      'AT',
      'DE',
      'CH',
      'AX',
      'DK',
      'FO',
      'FI',
      'IS',
      'NO',
      'SJ',
      'SE',
      'AD',
      'VA',
      'MT',
      'PT',
      'SM',
      'ES',
      'BV',
      'IO',
      'TF',
      'GI',
      'GG',
      'IE',
      'IM',
      'JE',
      'GS',
      'GB',
      'FR',
      'MC',
      'IT',
      'RU'
    ],
    footerData: [
      {
        title: 'Entertainment',
        link: '',
        data: [
          {
            title: 'Zee Marathi HD',
            link: '/live-tv/zee-marathi-hd/0-9-zeemarathi'
          },
          {
            title: 'Zee TV',
            link: '/live-tv/zee-tv-hd-uk/0-9-zeetvuk'
          },
          {
            title: 'Zee Kannada HD',
            link: '/live-tv/zee-kannada-hd/0-9-zeekannada'
          },
          {
            title: 'Zee Keralam HD',
            link: '/live-tv/zee-keralam-hd/0-9-129'
          },
          {
            title: 'Zee Telugu HD',
            link: '/live-tv/zee-telugu-hd/0-9-zeetelugu'
          }
        ]
      },
      {
        title: 'Movies',
        link: '',
        data: [
          {
            title: 'Zee Bollywood',
            link: '/live-tv/zee-bollywood/0-9-zeeclassic'
          },
          {
            title: 'Zee Cinema',
            link: '/live-tv/zee-cinema-uk/0-9-zeecinemauk'
          },
          {
            title: 'Zee Cinemalu HD',
            link: '/live-tv/zee-cinemalu-hd/0-9-zeecinemalu'
          },
          {
            title: 'Zee Talkies HD',
            link: '/live-tv/zee-talkies-hd/0-9-zeetalkies'
          },
          {
            title: 'Zee Thirai',
            link: '/live-tv/zee-thirai/0-9-224'
          }
        ]
      }
    ]
  },
  // Allowed country code for Africa Region //
  {
    allowedCountryRegionsList: [
      'BI',
      'KM',
      'DJ',
      'ER',
      'ET',
      'KE',
      'MG',
      'MW',
      'MU',
      'YT',
      'MZ',
      'RE',
      'RW',
      'SC',
      'SO',
      'SS',
      'TZ',
      'UG',
      'ZM',
      'ZW',
      'AO',
      'CM',
      'CF',
      'TD',
      'CG',
      'CD',
      'GQ',
      'GA',
      'ST',
      'BW',
      'LS',
      'NA',
      'ZA',
      'SZ',
      'BJ',
      'BF',
      'CV',
      'GM',
      'GH',
      'GN',
      'GW',
      'CI',
      'LR',
      'ML',
      'MR',
      'NE',
      'NG',
      'SH',
      'SN',
      'SL',
      'TG'
    ],
    footerData: [
      {
        title: 'Entertainment',
        link: '',
        data: [
          {
            title: 'Zee Kannada HD',
            link: '/live-tv/zee-kannada-hd/0-9-zeekannada'
          },
          {
            title: 'Zee Keralam HD',
            link: '/live-tv/zee-keralam-hd/0-9-129'
          },
          {
            title: 'Zee Marathi HD',
            link: '/live-tv/zee-marathi-hd/0-9-zeemarathi'
          },
          {
            title: 'Zee Tamil HD',
            link: '/live-tv/zee-tamil-hd/0-9-zeetamil'
          },
          {
            title: 'Zee Telugu HD',
            link: '/live-tv/zee-telugu-hd/0-9-zeetelugu'
          }
        ]
      },
      {
        title: 'Movies',
        link: '',
        data: [
          {
            title: 'Zee Bangla Cinema',
            link: '/live-tv/zee-bangla-cinema/0-9-zeebanglacinema'
          },
          {
            title: 'Zee Cinema ME',
            link: '/live-tv/zee-cinema-me/0-9-zeecinemaintl'
          },
          {
            title: 'Zee Cinemalu HD',
            link: '/live-tv/zee-cinemalu-hd/0-9-zeecinemalu'
          },
          {
            title: 'Zee Talkies HD',
            link: '/live-tv/zee-talkies-hd/0-9-zeetalkies'
          },
          {
            title: 'Zee Thirai',
            link: '/live-tv/zee-thirai/0-9-224'
          }
        ]
      }
    ]
  },
  // Allowed country code for Americas Region //
  {
    allowedCountryRegionsList: [
      'AI',
      'AQ',
      'AG',
      'AW',
      'BS',
      'BB',
      'BQ',
      'KY',
      'CW',
      'DM',
      'GD',
      'GP',
      'GY',
      'JM',
      'MQ',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'SR',
      'TT',
      'TC',
      'UM',
      'VG',
      'AR',
      'BZ',
      'BM',
      'BO',
      'BR',
      'CL',
      'CO',
      'CR',
      'CU',
      'DO',
      'EC',
      'SV',
      'FK',
      'GF',
      'GL',
      'GT',
      'HT',
      'HN',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'PM',
      'UY',
      'VE',
      'VI',
      'CA'
    ],
    footerData: [
      {
        title: 'Entertainment',
        link: '',
        data: [
          {
            title: '& TV HD',
            link: '/live-tv/andtv-hd-usa/0-9-channel_1510237423'
          },
          {
            title: 'Zee Yuva',
            link: '/live-tv/zee-yuva/0-9-zeeyuva'
          },
          {
            title: 'Zing',
            link: '/live-tv/zing-usa/0-9-channel_1643519345'
          },
          {
            title: 'ZEE TV',
            link: '/live-tv/zee-tv-usa/0-9-channel_1586895760'
          },
          {
            title: 'Zee Marathi',
            link: '/live-tv/zee-marathi-usa/0-9-channel_926372368'
          }
        ]
      },
      {
        title: 'Movies',
        link: '',
        data: [
          {
            title: 'Zee Bollywood',
            link: '/live-tv/zee-bollywood/0-9-zeeclassic'
          },
          {
            title: 'Zee Cinema',
            link: '/live-tv/zee-cinema-usa/0-9-179'
          },
          {
            title: 'Zee Cinemalu',
            link: '/live-tv/zee-cinemalu-hd/0-9-zeecinemalu'
          },
          {
            title: 'Zee Talkies',
            link: '/live-tv/zee-talkies-hd/0-9-zeetalkies'
          },
          {
            title: 'Zee Thirai',
            link: '/live-tv/zee-thirai/0-9-224'
          }
        ]
      }
    ]
  }
];

// child footer data
export const childFooterMoviesData = [
  {
    title: 'Movies By Language',
    slug: '',
    items: [
      {
        title: 'Hindi Movies',
        slug: '/movies/lang/hindi'
      },
      {
        title: 'Telugu Movies',
        slug: '/movies/lang/telugu'
      },
      {
        title: 'Tamil Movies',
        slug: '/movies/lang/tamil'
      },
      {
        title: 'Kannada Movies',
        slug: '/movies/lang/kannada'
      },
      {
        title: 'Marathi Movies',
        slug: '/movies/lang/marathi'
      },
      {
        title: 'Bengali Movies',
        slug: '/movies/lang/bengali'
      },
      {
        title: 'Malayalam Movies',
        slug: '/movies/lang/malayalam'
      },
      {
        title: 'English Movies',
        slug: '/movies/lang/english'
      },
      {
        title: 'Bhojpuri Movies',
        slug: '/movies/lang/bhojpuri'
      },
      {
        title: 'Punjabi Movies',
        slug: '/movies/lang/punjabi'
      }
    ]
  },
  {
    title: 'Movies By Genre',
    slug: '',
    items: [
      {
        title: 'Action Movies',
        slug: '/movies/genre/action'
      },
      {
        title: 'Comedy Movies',
        slug: '/movies/genre/comedy'
      },
      {
        title: 'Romantic Movies',
        slug: '/movies/genre/romance'
      },
      {
        title: 'Horror Movies',
        slug: '/movies/genre/horror'
      },
      {
        title: 'Crime Movies',
        slug: '/movies/genre/crime'
      },
      {
        title: 'Thriller Movies',
        slug: '/movies/genre/thriller'
      },
      {
        title: 'Animation Movies',
        slug: '/movies/genre/animation'
      },
      {
        title: 'Mythology Movies',
        slug: '/movies/genre/mythology'
      },
      {
        title: 'War Movies',
        slug: '/movies/genre/war'
      },
      {
        title: 'Sci-Fi Movies',
        slug: '/movies/genre/sci-fi'
      },
      {
        title: 'Sports Movies',
        slug: '/movies/genre/sports'
      }
    ]
  },
  {
    title: 'Movies By Celeb',
    slug: '',
    items: [
      {
        title: 'Salman Khan Movies',
        slug: '/celebs/salman-khan/filmograpghy'
      },
      {
        title: 'Sunny Leone Movies',
        slug: '/celebs/sunny-leone/filmograpghy'
      },
      {
        title: 'Amitabh Bachchan Movies',
        slug: '/celebs/amitabh-bachchan/filmograpghy'
      },
      {
        title: 'Vicky Kaushal Movies',
        slug: '/celebs/vicky-kaushal/filmograpghy'
      },
      {
        title: 'Nawazuddin Siddiqui Movies',
        slug: '/celebs/nawazuddin-siddiqui/filmograpghy'
      },
      {
        title: 'Akshay Kumar Movies',
        slug: '/celebs/akshay-kumar/filmograpghy'
      },
      {
        title: 'Manoj Bajpayee Movies',
        slug: '/celebs/manoj-bajpayee/filmograpghy'
      },
      {
        title: 'Pooja Hegde Movies',
        slug: '/celebs/pooja-hegde/filmograpghy'
      },
      {
        title: 'Abhishek Bachchan Movies',
        slug: '/celebs/abhishek-bachchan/filmograpghy'
      },
      {
        title: 'Kangana Ranaut Movies',
        slug: '/celebs/kangana-ranaut/filmograpghy'
      },
      {
        title: 'Sunny Deol Movies',
        slug: '/celebs/sunny-deol/filmograpghy'
      },
      {
        title: 'Pankaj Tripathi Movies',
        slug: '/celebs/pankaj-tripathi/filmograpghy'
      }
    ]
  },
  {
    title: 'Movies By Year',
    slug: '/movies/year',
    items: [
      {
        title: 'New Movies',
        slug: '/movies/new-movies'
      },
      {
        title: '2024 Movies',
        slug: '/movies/year/2024'
      },
      {
        title: '2023 Movies',
        slug: '/movies/year/2023'
      },
      {
        title: '2022 Movies',
        slug: '/movies/year/2022'
      },
      {
        title: '2021 Movies',
        slug: '/movies/year/2021'
      },
      {
        title: '2020 Movies',
        slug: '/movies/year/2020'
      },
      {
        title: '2019 Movies',
        slug: '/movies/year/2019'
      },
      {
        title: '2018 Movies',
        slug: '/movies/year/2018'
      },
      {
        title: '2017 Movies',
        slug: '/movies/year/2017'
      },
      {
        title: '2016 Movies',
        slug: '/movies/year/2016'
      },
      {
        title: '2015 Movies',
        slug: '/movies/year/2015'
      }
    ]
  },
  {
    title: 'Top Bollywood Movies',
    slug: '/movies/bollywood',
    items: [
      {
        title: 'Berlin',
        slug: '/movies/details/berlin/0-0-1z5615527'
      },
      {
        title: 'Bhaiyya Ji',
        slug: '/movies/details/bhaiyya-ji/0-0-1z5595126'
      },
      {
        title: 'Kakuda',
        slug: '/movies/details/kakuda/0-0-1z5581177'
      },
      {
        title: 'Rautu Ka Raaz',
        slug: '/movies/details/rautu-ka-raaz/0-0-1z5577122'
      },
      {
        title: 'Swatantrya Veer Savarkar',
        slug: '/movies/details/swatantrya-veer-savarkar/0-0-1z5566630'
      },
      {
        title: 'Bastar',
        slug: '/movies/details/bastar-the-naxal-story/0-0-1z5559828'
      },
      {
        title: 'Silence 2',
        slug: '/movies/details/silence-2-the-night-owl-bar-shootout/0-0-1z5535878'
      },
      {
        title: 'Main Atal Hoon',
        slug: '/movies/details/main-atal-hoon/0-0-1z5528544'
      },
      {
        title: 'The Kerala Story',
        slug: '/movies/details/the-kerala-story/0-0-1z5512788'
      },
      {
        title: 'Sam Bahadur',
        slug: '/movies/details/sam-bahadur/0-0-1z5500337'
      },
      {
        title: 'Kadak Singh',
        slug: '/movies/details/kadak-singh/0-0-1z5469034'
      },
      {
        title: 'Ghoomer',
        slug: '/movies/details/ghoomer/0-0-1z5454041'
      },
      {
        title: 'Gadar 2',
        slug: '/movies/details/gadar-2/0-0-1z5437988'
      },
      {
        title: 'Bandaa',
        slug: '/movies/details/sirf-ek-bandaa-kaafi-hai/0-0-1z5359029'
      },
      {
        title: 'The Kashmir Files',
        slug: '/movies/details/the-kashmir-files/0-0-1z5133458'
      },
      {
        title: 'Uri: The Surgical Strike',
        slug: '/movies/details/uri-the-surgical-strike/0-0-33204'
      },
      {
        title: 'Raksha Bandhan',
        slug: '/movies/details/raksha-bandhan/0-0-1z5228525'
      }
    ]
  },
  {
    title: 'Top South Movies',
    slug: '/movies/south',
    items: [
      {
        title: 'RRR',
        slug: '/movies/details/rrr/0-0-1z5145092'
      },
      {
        title: 'Hanu-Man',
        slug: '/movies/details/hanu-man/0-0-1z5531939'
      },
      {
        title: 'Gaami',
        slug: '/movies/details/gaami/0-0-1z5542628'
      },
      {
        title: 'Kaatera',
        slug: '/movies/details/kaatera/0-0-1z5508837'
      },
      {
        title: 'Prema Vimanam',
        slug: '/movies/details/prema-vimanam/0-0-1z5351501'
      },
      {
        title: 'Viduthalai Part-1',
        slug: '/movies/details/viduthalai-part-1/0-0-1z5351468'
      },
      {
        title: 'Agilan',
        slug: '/movies/details/agilan/0-0-1z5335031'
      },
      {
        title: 'Karthikeya 2',
        slug: '/movies/details/karthikeya-2/0-0-1z5227557'
      },
      {
        title: 'Macherla Niyojakavargam',
        slug: '/movies/details/macherla-niyojakavargam/0-0-1z5262283'
      },
      {
        title: 'Vikram',
        slug: '/movies/details/vikram/0-0-1z5215369'
      },
      {
        title: 'Captain',
        slug: '/movies/details/captain/0-0-1z5226617'
      },
      {
        title: 'Valimai',
        slug: '/movies/details/valimai/0-0-1z5117562'
      },
      {
        title: 'Paappan',
        slug: '/movies/details/paappan/0-0-1z5210827'
      },
      {
        title: 'Vedha',
        slug: '/movies/details/vedha/0-0-1z5294923'
      }
    ]
  }
];

export const childFooterShowsData = [
  {
    title: 'TV Shows By Language',
    slug: '',
    items: [
      {
        title: 'Hindi TV Shows',
        slug: '/tv-shows/lang/hindi'
      },
      {
        title: 'Marathi TV Shows',
        slug: '/tv-shows/lang/marathi'
      },
      {
        title: 'Tamil TV Shows',
        slug: '/tv-shows/lang/tamil'
      },
      {
        title: 'Telugu TV Shows',
        slug: '/tv-shows/lang/telugu'
      },
      {
        title: 'Malayalam TV Shows',
        slug: '/tv-shows/lang/malayalam'
      },
      {
        title: 'Punjabi TV Shows',
        slug: '/tv-shows/lang/punjabi'
      }
    ]
  },
  {
    title: 'TV Shows By Genre',
    slug: '',
    items: [
      {
        title: 'Drama TV Shows',
        slug: '/tv-shows/genre/drama'
      },
      {
        title: 'Romantic TV Shows',
        slug: '/tv-shows/genre/romance'
      },
      {
        title: 'Family TV Shows',
        slug: '/tv-shows/genre/family'
      },
      {
        title: 'Comedy TV Shows',
        slug: '/tv-shows/genre/comedy'
      },
      {
        title: 'Reality TV Shows',
        slug: '/tv-shows/genre/reality'
      },
      {
        title: 'Supernatural TV Shows',
        slug: '/tv-shows/genre/supernatural'
      }
    ]
  },
  {
    title: 'TV Shows By Channel',
    slug: '',
    items: [
      {
        title: 'Zee TV Shows',
        slug: '/tv-shows/zee-tv/0-9-zeetv'
      },
      {
        title: '&TV Shows',
        slug: '/tv-shows/andtv-hd/0-9-tvhd_0'
      },
      {
        title: 'Zee Marathi Shows',
        slug: '/tv-shows/zee-marathi-hd/0-9-zeemarathi'
      },
      {
        title: 'Zee Kannada Shows',
        slug: '/tv-shows/zee-kannada-hd/0-9-zeekannada'
      },
      {
        title: 'Zee Tamil Shows',
        slug: '/tv-shows/zee-tamil-hd/0-9-zeetamil'
      },
      {
        title: 'Zee Bangla Shows',
        slug: '/tv-shows/zee-bangla-hd/0-9-zeebangla'
      }
    ]
  },
  {
    title: 'Must-Watch Hindi TV Shows',
    slug: '',
    items: [
      {
        title: 'Jodha Akbar',
        slug: '/tv-shows/details/jodha-akbar/0-6-447'
      },
      {
        title: 'Yeh Teri Galiyan',
        slug: '/tv-shows/details/yeh-teri-galiyan/0-6-tvshow_826525818'
      },
      {
        title: 'Apna Time Bhi Aayega',
        slug: '/tv-shows/details/apna-time-bhi-aayega/0-6-3008'
      },
      {
        title: 'Pavitra Rishta',
        slug: '/tv-shows/details/pavitra-rishta/0-6-133'
      },
      {
        title: 'Qubool Hai',
        slug: '/tv-shows/details/qubool-hai/0-6-135'
      },
      {
        title: 'Teri Meri Ikk Jindri',
        slug: '/tv-shows/details/teri-meri-ikk-jindri/0-6-3137'
      }
    ]
  },
  {
    title: 'Must-Watch Marathi TV Shows',
    slug: '',
    items: [
      {
        title: 'Mazhi Tuzhi Reshimgaath',
        slug: '/tv-shows/details/mazhi-tuzhi-reshimgaath/0-6-3521'
      },
      {
        title: 'Yeu Kashi Tashi Me Nandayla',
        slug: '/tv-shows/details/yeu-kashi-tashi-me-nandayla/0-6-3122'
      },
      {
        title: 'Lagira Zhala Jee',
        slug: '/tv-shows/details/lagira-zhala-jee/0-6-339'
      },
      {
        title: 'Man Udu Udu Zhala',
        slug: '/tv-shows/details/man-udu-udu-zhala/0-6-3525'
      },
      {
        title: 'Phulpakhru',
        slug: '/tv-shows/details/phulpakhru/0-6-336'
      },
      {
        title: 'Swarajyarakshak Sambhaji',
        slug: '/tv-shows/details/swarajyarakshak-sambhaji/0-6-662'
      }
    ]
  },
  {
    title: 'Latest TV Shows',
    slug: '',
    items: [
      {
        title: 'Rishton ka Manjha',
        slug: '/tv-shows/details/rishton-ka-manjha/0-6-3522'
      },
      {
        title: 'Meet',
        slug: '/tv-shows/details/meet/0-6-3510'
      },
      {
        title: 'Bhagya Lakshmi',
        slug: '/tv-shows/details/bhagya-lakshmi/0-6-3392'
      },
      {
        title: 'Zee Comedy Show',
        slug: '/tv-shows/details/zee-comedy-show/0-6-3420'
      },
      {
        title: 'Mauka-E-Vardaat',
        slug: '/tv-shows/details/mauka-e-vardaat/0-6-3198'
      },
      {
        title: 'Ghar Ek Mandir Kripa Agrasen Maharaj Ki',
        slug: '/tv-shows/details/ghar-ek-mandir-kripa-agrasen-maharaj-ki/0-6-3508'
      }
    ]
  }
];
export const childFooterSeriesData = [
  {
    title: 'Web Series By Language',
    slug: '',
    items: [
      {
        title: 'Hindi Web Series',
        slug: '/web-series/lang/hindi'
      },
      {
        title: 'Tamil Web Series',
        slug: '/web-series/lang/tamil'
      },
      {
        title: 'Bengali Web Series',
        slug: '/web-series/lang/bengali'
      },
      {
        title: 'Telugu Web Series',
        slug: '/web-series/lang/telugu'
      },
      {
        title: 'Marathi Web Series',
        slug: '/web-series/lang/marathi'
      },
      {
        title: 'Malayalam Web Series',
        slug: '/web-series/lang/malayalam'
      }
    ]
  },
  {
    title: 'Web Series By Genre',
    slug: '',
    items: [
      {
        title: 'Crime Web Series',
        slug: '/web-series/genre/crime'
      },
      {
        title: 'Comedy Web Series',
        slug: '/web-series/genre/comedy'
      },
      {
        title: 'Action Web Series',
        slug: '/web-series/genre/actions'
      },
      {
        title: 'Drama Web Series',
        slug: '/web-series/genre/drama'
      },
      {
        title: 'Thriller Web Series',
        slug: '/web-series/genre/thriller'
      },
      {
        title: 'Romantic Web Series',
        slug: '/web-series/genre/romance'
      }
    ]
  },
  {
    title: 'Latest Web Series',
    slug: '',
    items: [
      {
        title: 'Murshid',
        slug: '/web-series/details/murshid/0-6-4z5612057'
      },
      {
        title: 'Gyaarah Gyaarah',
        slug: '/web-series/details/gyaarah-gyaarah/0-6-4z5371966'
      },
      {
        title: 'Manorathangal',
        slug: '/web-series/details/manorathangal/0-6-4z5594936'
      },
      {
        title: 'Kaantaye Kaantaye',
        slug: '/web-series/details/kaantaye-kaantaye/0-6-4z5598539'
      },
      {
        title: 'The Broken News',
        slug: '/web-series/details/the-broken-news/0-6-4z5145215'
      },
      {
        title: 'Paruvu',
        slug: '/web-series/details/paruvu/0-6-4z5570736'
      },
      {
        title: 'Thalaimai Seyalagam',
        slug: '/web-series/details/thalaimai-seyalagam/0-6-4z5556586'
      },
      {
        title: 'Thalaimai Seyalagam',
        slug: '/web-series/details/thalaimai-seyalagam/0-6-4z5556586'
      },
      {
        title: 'Break Point',
        slug: '/web-series/details/break-point/0-6-3444'
      },
      {
        title: 'Sunflower',
        slug: '/web-series/details/sunflower/0-6-3284'
      },
      {
        title: 'Tripling',
        slug: '/web-series/details/tripling/0-6-4z5230436'
      }
    ]
  },
  {
    title: 'Must-Watch Web Series',
    slug: '',
    items: [
      {
        title: 'Nisha',
        slug: '/web-series/details/nisha/0-6-2175'
      },
      {
        title: 'Mafia',
        slug: '/web-series/details/mafia/0-6-2881'
      },
      {
        title: 'Taish',
        slug: '/web-series/details/taish/0-6-3044'
      },
      {
        title: 'The Married Woman',
        slug: '/web-series/details/the-married-woman/0-6-3189'
      },
      {
        title: 'Code M',
        slug: '/web-series/details/code-m/0-6-2395'
      },
      {
        title: 'Qubool Hai 2.0',
        slug: '/web-series/details/qubool-hai-20/0-6-3190'
      }
    ]
  }
];

// Global data
export const childFooterMovieGlobal = [
  {
    title: 'Movies by Popular Language',
    slug: '',
    items: [
      {
        title: 'Hindi Movies',
        slug: '/movies/lang/hindi'
      },
      {
        title: 'Punjabi Movies',
        slug: '/movies/lang/punjabi'
      },
      {
        title: 'Tamil Movies',
        slug: '/movies/lang/tamil'
      },
      {
        title: 'Telugu Movies',
        slug: '/movies/lang/telugu'
      },
      {
        title: 'Bhojpuri Movies',
        slug: '/movies/lang/bhojpuri'
      },
      {
        title: 'Kannada Movies',
        slug: '/movies/lang/kannada'
      },
      {
        title: 'Marathi Movies',
        slug: '/movies/lang/marathi'
      },
      {
        title: 'English Movies',
        slug: '/movies/lang/english'
      },
      {
        title: 'Malayalam Movies',
        slug: '/movies/lang/malayalam'
      },
      {
        title: 'Bengali Movies',
        slug: '/movies/lang/bengali'
      }
    ]
  },
  {
    title: 'Movies by Popular Genre',
    slug: '',
    items: [
      {
        title: 'Comedy Movies',
        slug: '/movies/genre/comedy'
      },
      {
        title: 'Romance Movies',
        slug: '/movies/genre/romance'
      },
      {
        title: 'Thriller Movies',
        slug: '/movies/genre/thriller'
      },
      {
        title: 'Horror Movies',
        slug: '/movies/genre/horror'
      },
      {
        title: 'Action Movies',
        slug: '/movies/genre/action'
      },
      {
        title: 'Family Movies',
        slug: '/movies/genre/family'
      },
      {
        title: 'Drama Movies',
        slug: '/movies/genre/drama'
      },
      {
        title: 'Adventure Movies',
        slug: '/movies/genre/adventure'
      },
      {
        title: 'Kids Movies',
        slug: '/movies/genre/kids'
      },
      {
        title: 'Crime Movies',
        slug: '/movies/genre/crime'
      }
    ]
  },
  {
    title: 'Language & Genre Movies',
    slug: '',
    items: [
      {
        title: 'Hindi Comedy Movies',
        slug: '/movies/genre/comedy/hindi'
      },
      {
        title: 'Malayalam Comedy Movies',
        slug: '/movies/genre/comedy/malayalam'
      },
      {
        title: 'Tamil Comedy Movies',
        slug: '/movies/genre/comedy/tamil'
      },
      {
        title: 'Tamil Thriller Movies',
        slug: '/movies/genre/thriller/tamil'
      },
      {
        title: 'Hindi Horror Movies',
        slug: '/movies/genre/horror/hindi'
      },
      {
        title: 'Hindi Thriller Movies',
        slug: '/movies/genre/thriller/hindi'
      },
      {
        title: 'Hindi Romantic Movies',
        slug: '/movies/genre/romantic/hindi'
      },
      {
        title: 'Malayalam Thriller Movies',
        slug: '/movies/genre/thriller/malayalam'
      },
      {
        title: 'Hindi Action Movies',
        slug: '/movies/genre/action/hindi'
      },
      {
        title: 'Tamil Action Movies',
        slug: '/movies/genre/action/tamil'
      }
    ]
  },
  {
    title: 'Popular Actor Movies',
    slug: '',
    items: [
      {
        title: 'Salman Khan Movies',
        slug: '/celebs/salman-khan/filmograpghy'
      },
      {
        title: 'Rajkummar Rao Movies',
        slug: '/celebs/rajkummar-rao/filmograpghy'
      },
      {
        title: 'Shahid Kapoor Movies',
        slug: '/celebs/shahid-kapoor/filmograpghy'
      },
      {
        title: 'Ranbir Kapoor Movies',
        slug: '/celebs/ranbir-kapoor/filmograpghy'
      },
      {
        title: 'Akshay Kumar Movies',
        slug: '/celebs/akshay-kumar/filmograpghy'
      },
      {
        title: 'Kareena Kapoor Movies',
        slug: '/celebs/kareena-kapoor/filmograpghy'
      },
      {
        title: 'Irrfan Khan Movies',
        slug: '/celebs/irrfan-khan'
      },
      {
        title: 'Vicky Kaushal Movies',
        slug: '/celebs/vicky-kaushal'
      },
      {
        title: 'Nawazuddin Siddiqui Movies',
        slug: '/celebs/nawazuddin-siddiqui'
      },
      {
        title: 'Katrina Kaif Movies',
        slug: '/celebs/katrina-kaif'
      }
    ]
  },
  {
    title: 'Movies by Year',
    slug: '',
    items: [
      {
        title: 'Movies 2022',
        slug: '/movies/year/2022'
      },
      {
        title: 'Movies 2021',
        slug: '/movies/year/2021'
      },
      {
        title: 'Movies 2020',
        slug: '/movies/year/2020'
      },
      {
        title: 'Movies 2019',
        slug: '/movies/year/2019'
      },
      {
        title: 'Movies 2018',
        slug: '/movies/year/2018'
      },
      {
        title: 'Movies 2017',
        slug: '/movies/year/2017'
      },
      {
        title: 'Movies 2016',
        slug: '/movies/year/2016'
      },
      {
        title: 'Movies 2015',
        slug: '/movies/year/2015'
      },
      {
        title: 'Movies 2014',
        slug: '/movies/year/2014'
      },
      {
        title: 'Movies 2013',
        slug: '/movies/year/2013'
      }
    ]
  },
  {
    title: 'Top Movies',
    slug: '',
    items: [
      {
        title: 'Bastar ',
        slug: '/movies/details/bastar-the-naxal-story/0-0-1z5559828'
      },
      {
        title: 'Farrey',
        slug: '/movies/details/farrey/0-0-1z5535565'
      },
      {
        title: 'Hanu-man',
        slug: '/movies/details/hanu-man/0-0-1z5531939'
      },
      {
        title: 'Main Atal hoon',
        slug: '/movies/details/main-atal-hoon/0-0-1z5528544'
      },
      {
        title: 'The Kerala Story',
        slug: '/movies/details/the-kerala-story/0-0-1z5512788'
      },
      {
        title: 'Sam Bahadur',
        slug: '/movies/details/sam-bahadur/0-0-1z5500337'
      },
      {
        title: 'Ghost',
        slug: '/movies/details/ghost/0-0-1z5465536'
      },
      {
        title: 'Ghoomer',
        slug: '/movies/details/ghoomer/0-0-1z5454041'
      },
      {
        title: 'Gadar 2',
        slug: '/movies/details/gadar-2/0-0-1z5437988'
      },
      {
        title: 'Wanted',
        slug: '/movies/details/wanted/0-0-2463'
      }
    ]
  }
];
export const childFooterShowsGlobal = [
  {
    title: 'TV Shows by Popular Language',
    slug: '',
    items: [
      {
        title: 'Tamil TV Shows',
        slug: '/tv-shows/lang/tamil',
        external: true
      },
      {
        title: 'English TV Shows',
        slug: '/tv-shows/lang/english'
      },
      {
        title: 'Hindi TV Shows',
        slug: '/tv-shows/lang/hindi'
      },
      {
        title: 'Telugu TV Shows',
        slug: '/tv-shows/lang/telugu'
      },
      {
        title: 'Bengali TV Shows',
        slug: '/tv-shows/lang/bengali'
      },
      {
        title: 'Punjabi TV Shows',
        slug: '/tv-shows/lang/punjabi'
      },
      {
        title: 'Malayalam TV Shows',
        slug: '/tv-shows/lang/malayalam'
      },
      {
        title: 'Bhojpuri TV Shows',
        slug: '/tv-shows/lang/bhojpuri'
      },
      {
        title: 'Kannada TV Shows',
        slug: '/tv-shows/lang/kannada'
      },
      {
        title: 'Marathi TV Shows',
        slug: '/tv-shows/lang/marathi'
      }
    ]
  },
  {
    title: 'TV Shows by Popular Genre',
    slug: '',
    items: [
      {
        title: 'Reality TV Shows',
        slug: '/tv-shows/genre/reality'
      },
      {
        title: 'Comedy TV Shows',
        slug: '/tv-shows/genre/comedy'
      },
      {
        title: 'Family TV Shows',
        slug: '/tv-shows/genre/family'
      },
      {
        title: 'Crime TV Shows',
        slug: '/tv-shows/genre/crime'
      },
      {
        title: 'Horror TV Shows',
        slug: '/tv-shows/genre/horror'
      },
      {
        title: 'Romantic TV Shows',
        slug: '/tv-shows/genre/romance'
      },
      {
        title: 'Drama TV Shows',
        slug: '/tv-shows/genre/drama'
      },
      {
        title: 'Thriller TV Shows',
        slug: '/tv-shows/genre/thriller'
      },
      {
        title: 'Mythology TV Shows',
        slug: '/tv-shows/genre/mythology'
      },
      {
        title: 'Suspense TV Shows',
        slug: '/tv-shows/genre/suspense'
      }
    ]
  },
  {
    title: 'Popular TV Shows',
    slug: '',
    items: [
      {
        title: 'Kundali Bhagya',
        slug: '/tv-shows/details/kundali-bhagya/0-6-366'
      },
      {
        title: 'Bhagya Lakshmi',
        slug: '/tv-shows/details/bhagya-lakshmi/0-6-3392'
      },
      {
        title: 'Mithai',
        slug: '/tv-shows/details/mithai/0-6-3121'
      },
      {
        title: 'Apna Time Bhi Aayega',
        slug: '/tv-shows/details/apna-time-bhi-aayega/0-6-3008'
      },
      {
        title: 'Tere Bina Jiya Jaye Na',
        slug: '/tv-shows/details/tere-bina-jiya-jaye-na/0-6-4z525220'
      },
      {
        title: 'Anbe Sivam',
        slug: '/tv-shows/details/mrs-hitler/0-6-3293'
      },
      {
        title: 'Jhansi Ki Rani',
        slug: '/tv-shows/details/jhansi-ki-rani/0-6-124'
      },
      {
        title: 'Zindagi Ki Mehek',
        slug: '/tv-shows/details/zindagi-ki-mehek/0-6-271'
      },
      {
        title: 'Sembaruthi',
        slug: '/tv-shows/details/sembaruthi/0-6-675'
      },
      {
        title: 'Meet',
        slug: '/tv-shows/details/meet/0-6-3510'
      }
    ]
  },
  {
    title: 'Evergreen TV Shows',
    slug: '',
    items: [
      {
        title: 'Tripling',
        slug: '/tv-shows/details/tripling/0-6-3350'
      },
      {
        title: 'Kumkum Bhagya',
        slug: '/tv-shows/details/kumkum-bhagya/0-6-127'
      },
      {
        title: 'Mahabharat',
        slug: '/tv-shows/details/mahabharat/0-6-3331'
      },
      {
        title: 'Jodha Akbar',
        slug: '/tv-shows/details/jodha-akbar/0-6-447'
      },
      {
        title: 'Pavitra Rishta',
        slug: '/tv-shows/details/pavitra-rishta/0-6-133'
      },
      {
        title: 'Sa Re Ga Ma Pa',
        slug: '/tv-shows/details/sa-re-ga-ma-pa-2021/0-6-3497'
      },
      {
        title: 'Qubool Hai',
        slug: '/tv-shows/details/qubool-hai/0-6-135'
      },
      {
        title: 'Dance India Dance',
        slug: '/tv-shows/details/dance-india-dance-lil-masters-season-5/0-6-4z587441'
      },
      {
        title: 'Permanent roommates',
        slug: '/tv-shows/details/permanent-roommates/0-6-3346'
      },
      {
        title: 'Karthika Deepam',
        slug: '/tv-shows/details/karthika-deepam/0-6-2886'
      }
    ]
  }
];

export const childFooterSeriesGlobal = [
  {
    title: 'Web Series by Popular Lang & Genre',
    slug: '',
    items: [
      {
        title: 'Hindi Thriller Web Series',
        slug: '/web-series/genre/thriller/hindi'
      },
      {
        title: 'Hindi Comedy Web Series',
        slug: '/web-series/genre/comedy/hindi'
      },
      {
        title: 'Hindi Crime Web Series',
        slug: '/web-series/genre/crime/hindi'
      },
      {
        title: 'Hindi Family Web Series',
        slug: '/web-series/genre/family/hindi'
      },
      {
        title: 'Hindi Horror Web Series',
        slug: '/web-series/genre/horror/hindi'
      },
      {
        title: 'Hindi Romance Web Series',
        slug: '/web-series/genre/romance/hindi'
      },
      {
        title: 'Hindi Action Web Series',
        slug: '/web-series/genre/action/hindi'
      },
      {
        title: 'Hindi Suspense Web Series',
        slug: '/web-series/genre/suspense/hindi'
      },
      {
        title: 'Telugu Comedy Web Series',
        slug: '/web-series/genre/comedy/telugu'
      },
      {
        title: 'Tamil Comedy Web Series',
        slug: '/web-series/genre/comedy/tamil'
      }
    ]
  },
  {
    title: 'Web Series by Popular Genre',
    slug: '',
    items: [
      {
        title: 'Animation Web Series',
        slug: '/web-series/genre/animation'
      },
      {
        title: 'Thriller Web Series',
        slug: '/web-series/genre/thriller'
      },
      {
        title: 'Comedy Web Series',
        slug: '/web-series/genre/comedy'
      },
      {
        title: 'Romantic Web Series',
        slug: '/web-series/genre/romance'
      },
      {
        title: 'Sci Fi Web Series',
        slug: '/web-series/genre/sci-fi'
      },
      {
        title: 'Family Web Series',
        slug: '/web-series/genre/family'
      },
      {
        title: 'Action Web Series',
        slug: '/web-series/genre/action'
      },
      {
        title: 'Fantasy Web Series',
        slug: '/web-series/genre/fantasy'
      },
      {
        title: 'Mystery Web Series',
        slug: '/web-series/genre/mystery'
      },
      {
        title: 'Suspense Web Series',
        slug: '/web-series/genre/suspense'
      }
    ]
  },
  {
    title: 'Trending & Popular Web Series',
    slug: '',
    items: [
      {
        title: 'Pavitra Rishta 2.0',
        slug: '/web-series/details/pavitra-rishta-20-its-never-too-late/0-6-3502'
      },
      {
        title: 'The Final Call',
        slug: '/web-series/details/the-final-call/0-6-1290'
      },
      {
        title: 'Broken But Beautiful',
        slug: '/web-series/details/broken-but-beautiful-season-2/0-6-2211'
      },
      {
        title: 'State Of Siege',
        slug: '/web-series/details/state-of-siege-2611/0-6-2370'
      },
      {
        title: 'Churails',
        slug: '/web-series/details/churails/0-6-2922'
      },
      {
        title: 'Rangbaaz',
        slug: '/web-series/details/rangbaaz/0-6-1138'
      },
      {
        title: 'Taish',
        slug: '/web-series/details/taish/0-6-3044'
      },
      {
        title: 'Abhay',
        slug: '/web-series/details/abhay/0-6-1298'
      },
      {
        title: 'Mentalhood',
        slug: '/web-series/details/mentalhood/0-6-2471'
      },
      {
        title: 'Oka Chinna Family Story',
        slug: '/web-series/details/oka-chinna-family-story/0-6-4z535664'
      }
    ]
  },
  {
    title: 'Popular Web Series',
    slug: '',
    items: [
      {
        title: 'Kaafir',
        slug: '/web-series/details/kaafir/0-6-1741'
      },
      {
        title: 'Baarish',
        slug: '/web-series/details/baarish/0-6-2614'
      },
      {
        title: 'Code M',
        slug: '/web-series/details/code-m/0-6-2395'
      },
      {
        title: 'Dhoop Ki Deewar',
        slug: '/web-series/details/dhoop-ki-deewar/0-6-3347'
      },
      {
        title: 'The Married Woman',
        slug: '/web-series/details/the-married-woman/0-6-3189'
      },
      {
        title: 'Bicchoo Ka Khel',
        slug: '/web-series/details/bicchoo-ka-khel/0-6-3064'
      },
      {
        title: 'Sunflower',
        slug: '/web-series/details/sunflower/0-6-3284'
      },
      {
        title: 'Bebaakee',
        slug: '/web-series/details/bebaakee/0-6-2909'
      },
      {
        title: 'Jeet ki Zid',
        slug: '/web-series/details/jeet-ki-zid/0-6-2955'
      },
      {
        title: 'Naxalbari',
        slug: '/web-series/details/naxalbari/0-6-2923'
      }
    ]
  },
  {
    title: 'Latest & Upcoming Web Series',
    slug: '',
    items: [
      {
        title: 'The Broken News 1 & 2',
        slug: '/web-series/details/the-broken-news/0-6-4z5145215'
      },
      {
        title: 'Sunflower S1 & S2',
        slug: '/web-series/details/sunflower/0-6-3284'
      },
      {
        title: 'Duranga S1 & S2',
        slug: '/web-series/details/duranga/0-6-4z5193948'
      },
      {
        title: 'Never Kiss Your Best Friend',
        slug: '/web-series/details/never-kiss-your-best-friend/0-6-2356'
      },
      {
        title: 'Abhay Season 3',
        slug: '/web-series/details/abhay/0-6-1298'
      },
      {
        title: 'Qatil Haseenaon ke Naam',
        slug: '/web-series/details/qatil-haseenaon-ke-naam/0-6-4z543444'
      },
      {
        title: 'Bloody Brothers',
        slug: '/web-series/details/bloody-brothers/0-6-4z596111'
      },
      {
        title: 'Mithya',
        slug: '/web-series/details/mithya/0-6-4z587408'
      },
      {
        title: 'Sutliyan',
        slug: '/web-series/details/sutliyan/0-6-4z597039'
      },
      {
        title: 'Loser 2',
        slug: '/web-series/details/loser/0-6-2608'
      }
    ]
  }
];
